import { type Store } from '@service-initiation/shared-clients-tech-care-services';

import { locateStores } from './locateStores';
import {
  type GeoLocation,
  type ParsedStore,
  type StoreAttributeAndValue,
} from './types';
import { parseStores } from './utils';

export type GetStoresParams = {
  calcNextAvailability?: boolean;
  filterByStoreAttributeAndValue?: StoreAttributeAndValue;
  fullAddress?: string;
  geoLocation?: GeoLocation;
  maxDistance?: number;
  maxNumOfStoresToReturn?: number;
  postalCode?: string;
};

export const getStores = async ({
  calcNextAvailability = false,
  filterByStoreAttributeAndValue,
  fullAddress,
  geoLocation,
  maxDistance = 60,
  maxNumOfStoresToReturn = 10,
  postalCode,
}: GetStoresParams): Promise<ParsedStore[]> => {
  const serverResponse: Store[] = await locateStores({
    calcNextAvailability,
    fullAddress,
    geoLocation,
    maxDistance,
    maxNumOfStoresToReturn,
    postalCode,
  });
  return await parseStores(
    serverResponse,
    calcNextAvailability,
    filterByStoreAttributeAndValue
  );
};
